<template>
<div class="chapter">
<div class="inner_page">
<h1>Part One</h1>
<h3 class="sigil_not_in_toc"><i>Designer Genes</i></h3>
<p class="first" style="text-align: center;">He who only sees fashion in fashion is nothing but a fool.</p>
<p class="first" style="text-align: center;">—H<span class="small">ONORÉ DE</span> B<span class="small">ALZAC</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_part01.vue?080f4d16